import React, { lazy } from 'react';
import DonutGraphInfo from '../../DonutGraphInfo';
import { titleToolTip } from './titleToolTip';

const layout = window?.$environment?.CURRENT_LAYOUT;
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
const RangeInfo = lazy(() => import(`../../RangeInfo`));

export const graphContainer = (title = '', data, small = false, info = '', isAccident = false, tooltip = null, scoreDes) => {
  return (
    <div className="graph-container">
      {small ? (
        tooltip ? (
          titleToolTip(title, tooltip, 'titleSmall', true, true)
        ) : (
          <Label className="titleSmall">{title}</Label>
        )
      ) : (
        <SubHeader
          variant="h1"
          className="statsHeading"
          text={tooltip ? titleToolTip(title, tooltip, 'titleSmall', true, true) : title}
        />
      )}
      <div className={`fleet-score-graph ${small ? 'smallGraph' : ''}`}>
        <div className="div60">
          <DonutGraphInfo
            backgroundColor={isAccident ? ['green', 'yellow', 'orange', 'red'] : ['green', 'yellow', 'red']}
            data={data?.chartData}
            centerTextData={{
              count: data?.totalScore,
              text: scoreDes?.actualScore,
            }}
            small
          />
        </div>
        <div className="div40">
          <RangeInfo smallGraph={small} isAccident={isAccident} />
        </div>
      </div>
    </div>
  );
};
